import * as Yup from 'yup';
import capitalize from 'lodash/capitalize';

import { iaRa } from 'lib/helpers/utility';
import { formatDate } from 'lib/helpers/dateUtils';

import { FORM_TYPE_OPTIONS, PROVIDER_OPTIONS } from 'components/shared/Filters/lib/filterOptions';

import Actions from '../components/Actions';

import { formTypes } from './constants';

export const FormInitialValues = (form, packetIds) => ({
  form: {
    id: form?.id || null,
    name: form?.name || '',
    json: form?.json || null,
    type: form?.type || null
  },
  form_details: {
    create_type: form?.type || null,
    existing: form?.existing || null,
    integrate: form?.integration || null,
    receive: form?.receive || null
  },
  form_packet_ids: packetIds || []
});

export const FormValidationSchema = Yup.object().shape({
  form: Yup.object().shape({
    name: Yup.string().required('Name is required')
  })
});

export const getCurrentStep = (breadcrumbs, currentBreadcrumb) => {
  // const hiddenSteps = breadcrumbs.filter((breadcrumb) => breadcrumb.hidden);
  let index = breadcrumbs.findIndex((breadcrumb) => breadcrumb.view === currentBreadcrumb);
  if (index >= 0) {
    index = index + 1;
  }
  return index;
};

export const getStepsLeft = (breadcrumbs, currentBreadcrumb) => {
  //get breadcrumbs which are not hidden
  const nonHiddenSteps = breadcrumbs.filter((breadcrumb) => !breadcrumb.hidden);
  const currentIndex = nonHiddenSteps.findIndex(
    (breadcrumb) => breadcrumb.view === currentBreadcrumb
  );

  if (currentIndex === -1) {
    return -1;
  }

  const remainingSteps = nonHiddenSteps.slice(currentIndex + 1);

  return remainingSteps.length;
};
export const getAllStepsLeft = (breadcrumbs, currentBreadcrumb) => {
  //get all breadcrumbs with hidden included
  const currentIndex = breadcrumbs.findIndex((breadcrumb) => breadcrumb.view === currentBreadcrumb);

  if (currentIndex === -1) {
    return -1;
  }

  const remainingSteps = breadcrumbs.slice(currentIndex + 1);

  return remainingSteps.length;
};

export const formTypeFormatter = (value) => {
  const type = formTypes.find((form) => form.value === value);
  return type && type.label;
};

export const getAnswerLabel = (questionKey, answerValue) => {
  const answer = iaRa(questionKey?.answers).find((key) => key?.value === answerValue);
  return answer && answer?.title;
};

export const defaultColumns = () => [
  {
    field: 'name',
    headerName: 'Name',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? value : '-')
  },
  {
    field: 'formType',
    headerName: 'Form type',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? value?.name : '-')
  },
  {
    field: 'packets',
    headerName: 'Packets',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => value?.map((v) => (v.label ? v.label : '-'))
  },
  {
    field: 'version',
    headerName: 'Version',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? capitalize(value) : '-')
  },
  {
    field: 'created_at',
    headerName: 'Created at',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? formatDate(value) : '-')
  },
  {
    field: 'updated_at',
    headerName: 'Updated on',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? formatDate(value) : '-')
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellClass: 'no-border',
    cellRenderer: Actions,
    maxWidth: 88,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];

export const DEFAULT_FILTERS = {
  search: {
    type: 'search',
    fields: [
      { field: 'id', label: 'ID' },
      { field: 'name', label: 'Name' }
    ]
  },
  name: {
    title: 'Form name',
    placeholder: 'Search name',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'first-line-mono'
  },
  type: FORM_TYPE_OPTIONS,
  providers: PROVIDER_OPTIONS,
  version: {
    title: 'Version',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'note-2-mono'
  },
  created_at: {
    type: 'date-range',
    title: 'Date of creation',
    icon: 'calendar-mono'
  },
  updated_at: {
    type: 'date-range',
    title: 'Updated on',
    icon: 'calendar-2-mono'
  }
};
